import View from './view';

export default View.extend( {

    events: {
        'click .-edit'(e) {
            this.trigger( ':possible-value:edit-start', 
                this.options.value );
        },

        'click .-remove'(e) {
            this.trigger( ':possible-value:remove', 
                this.options.value );
        },

        'click .-order-up'(e) {
            this.trigger( ':possible-value:order-up', 
                this.options.value );
        },

        'click .-order-down'(e) {
            this.trigger( ':possible-value:order-down', 
                this.options.value );
        },
    },

    serialize() {
        const {value, type, isFirst, isLast} = this.options;
        return { value, type, isFirst, isLast, };
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/config.value.item.mode.view.js